import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";

import {
  FaClosedCaptioning,
  FaRegTimesCircle,
  FaTimesCircle,
  FaTrash,
} from "react-icons/fa";
const FeedbackModel = ({
  open,
  Transition,
  handleclose,
  Feedback,
  iserror,
  selectedOptions,
  handleButtonClick,
  handleSubmit,
  validated,
  setCommentData,
  CommentData,
  isLoading,
}) => {
  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleclose}
        aria-describedby="alert-dialog-slide-description"
        id="feedbackDialog"
        className="feedback-dialog-box"
      >
        <DialogTitle>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignContent: "center",
              alignItems: "center",
            }}
          >
            <span>Why did you choose this rating? (optional)</span>

            <span style={{ cursor: "pointer" }}>
              <FaRegTimesCircle
                style={{ color: "#999" }}
                onClick={handleclose}
              />
            </span>
          </div>

          {Feedback === "good" ? (
            <>
              <div
                style={{
                  fontSize: "14px",
                  paddingBottom: "10px",
                  paddingTop: "10px",
                }}
                className="feedback-description"
              >
                Thank you for the thumbs up, please select what did you like
                about the response.
              </div>
            </>
          ) : (
            <>
              <div
                style={{
                  fontSize: "14px",
                  paddingBottom: "10px",
                  paddingTop: "10px",
                }}
                className="feedback-description"
              >
                Sorry to hear you are not satisfied with the response, please
                select what did you not like about the response.
              </div>
            </>
          )}
        </DialogTitle>

        <DialogContent>
          {iserror && selectedOptions.length > 0 && (
            <div style={{ paddingBottom: "10px" }} className="error-msg">
              <Alert severity="error">
                Something went wrong, Please try again.
              </Alert>
            </div>
          )}

          {iserror && selectedOptions.length === 0 && (
            <div style={{ paddingBottom: "10px" }} className="error-msg">
              <Alert severity="error">
                Please select one of the following options.
              </Alert>
            </div>
          )}

          <DialogContentText id="alert-dialog-slide-description">
            <div
              style={{
                display: "flex",
                gap: "10px",
                paddingBottom: "1rem",
                flexWrap: "wrap",
              }}
            >
              {Feedback === "good" ? (
                <>
                  <Button
                    className={`goodBtn ${
                      selectedOptions.includes(
                        "My query was answered correctly"
                      )
                        ? "itemCheck"
                        : ""
                    }`}
                    onClick={() =>
                      handleButtonClick("My query was answered correctly")
                    }
                    variant={
                      selectedOptions.includes(
                        "My query was answered correctly"
                      )
                        ? "outlined"
                        : "outlined"
                    }
                  >
                    {selectedOptions.includes(
                      "My query was answered correctly"
                    ) && (
                      <CheckIcon
                        sx={{ paddingRight: "10px", fontSize: "30px" }}
                      />
                    )}{" "}
                    My query was answered correctly
                  </Button>
                  <Button
                    className={`goodBtn ${
                      selectedOptions.includes(
                        "Response length was appropriate, neither too short, nor too long"
                      )
                        ? "itemCheck"
                        : ""
                    }`}
                    onClick={() =>
                      handleButtonClick(
                        "Response length was appropriate, neither too short, nor too long"
                      )
                    }
                    variant={
                      selectedOptions.includes(
                        "Response length was appropriate, neither too short, nor too long"
                      )
                        ? "outlined"
                        : "outlined"
                    }
                  >
                    {selectedOptions.includes(
                      "Response length was appropriate, neither too short, nor too long"
                    ) && (
                      <CheckIcon
                        sx={{ paddingRight: "10px", fontSize: "30px" }}
                      />
                    )}{" "}
                    Response length was appropriate, neither too short, nor too
                    long
                  </Button>
                  <Button
                    className={`goodBtn ${
                      selectedOptions.includes(
                        "Chatbot's language and tone was friendly"
                      )
                        ? "itemCheck"
                        : ""
                    }`}
                    onClick={() =>
                      handleButtonClick(
                        "Chatbot's language and tone was friendly"
                      )
                    }
                    variant={
                      selectedOptions.includes(
                        "Chatbot's language and tone was friendly"
                      )
                        ? "outlined"
                        : "outlined"
                    }
                  >
                    {selectedOptions.includes(
                      "Chatbot's language and tone was friendly"
                    ) && (
                      <CheckIcon
                        sx={{ paddingRight: "10px", fontSize: "30px" }}
                      />
                    )}{" "}
                    Chatbot's language and tone was friendly
                  </Button>

                  <Button
                    className={`goodBtn ${
                      selectedOptions.includes(
                        "I did not have to wait much for the response"
                      )
                        ? "itemCheck"
                        : ""
                    }`}
                    onClick={() =>
                      handleButtonClick(
                        "I did not have to wait much for the response"
                      )
                    }
                    variant={
                      selectedOptions.includes(
                        "I did not have to wait much for the response"
                      )
                        ? "outlined"
                        : "outlined"
                    }
                  >
                    {selectedOptions.includes(
                      "I did not have to wait much for the response"
                    ) && (
                      <CheckIcon
                        sx={{ paddingRight: "10px", fontSize: "30px" }}
                      />
                    )}{" "}
                    I did not have to wait much for the response
                  </Button>

                  <Button
                    className={`goodBtn ${
                      selectedOptions.includes(
                        "Anything else, please elaborate"
                      )
                        ? "itemCheck"
                        : ""
                    }`}
                    onClick={() =>
                      handleButtonClick("Anything else, please elaborate")
                    }
                    variant={
                      selectedOptions.includes(
                        "Anything else, please elaborate"
                      )
                        ? "outlined"
                        : "outlined"
                    }
                  >
                    {selectedOptions.includes(
                      "Anything else, please elaborate"
                    ) && (
                      <CheckIcon
                        sx={{ paddingRight: "10px", fontSize: "30px" }}
                      />
                    )}{" "}
                    Anything else, please elaborate
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    className={`goodBtn ${
                      selectedOptions.includes(
                        "My query was answered incorrectly"
                      )
                        ? "itemCheck"
                        : ""
                    }`}
                    onClick={() =>
                      handleButtonClick("My query was answered incorrectly")
                    }
                    variant={
                      selectedOptions.includes(
                        "My query was answered incorrectly"
                      )
                        ? "outlined"
                        : "outlined"
                    }
                  >
                    {selectedOptions.includes(
                      "My query was answered incorrectly"
                    ) && (
                      <CheckIcon
                        sx={{ paddingRight: "10px", fontSize: "30px" }}
                      />
                    )}{" "}
                    My query was answered incorrectly
                  </Button>
                  <Button
                    className={`goodBtn ${
                      selectedOptions.includes("Response was too short")
                        ? "itemCheck"
                        : ""
                    }`}
                    onClick={() => handleButtonClick("Response was too short")}
                    variant={
                      selectedOptions.includes("Response was too short")
                        ? "outlined"
                        : "outlined"
                    }
                  >
                    {selectedOptions.includes("Response was too short") && (
                      <CheckIcon
                        sx={{ paddingRight: "10px", fontSize: "30px" }}
                      />
                    )}{" "}
                    Response was too short
                  </Button>
                  <Button
                    className={`goodBtn ${
                      selectedOptions.includes("Response was  too long")
                        ? "itemCheck"
                        : ""
                    }`}
                    onClick={() => handleButtonClick("Response was  too long")}
                    variant={
                      selectedOptions.includes("Response was  too long")
                        ? "outlined"
                        : "outlined"
                    }
                  >
                    {selectedOptions.includes("Response was  too long") && (
                      <CheckIcon
                        sx={{ paddingRight: "10px", fontSize: "30px" }}
                      />
                    )}{" "}
                    Response was too long
                  </Button>

                  <Button
                    className={`goodBtn ${
                      selectedOptions.includes(
                        "I did not find the chatbot's language or tone friendly"
                      )
                        ? "itemCheck"
                        : ""
                    }`}
                    onClick={() =>
                      handleButtonClick(
                        "I did not find the chatbot's language or tone friendly"
                      )
                    }
                    variant={
                      selectedOptions.includes(
                        "I did not find the chatbot's language or tone friendly"
                      )
                        ? "outlined"
                        : "outlined"
                    }
                  >
                    {selectedOptions.includes(
                      "I did not find the chatbot's language or tone friendly"
                    ) && (
                      <CheckIcon
                        sx={{ paddingRight: "10px", fontSize: "30px" }}
                      />
                    )}{" "}
                    I did not find the chatbot's language or tone friendly
                  </Button>
                  <Button
                    className={`goodBtn ${
                      selectedOptions.includes(
                        "I had to wait longer for a response"
                      )
                        ? "itemCheck"
                        : ""
                    }`}
                    onClick={() =>
                      handleButtonClick("I had to wait longer for a response")
                    }
                    variant={
                      selectedOptions.includes(
                        "I had to wait longer for a response"
                      )
                        ? "outlined"
                        : "outlined"
                    }
                  >
                    {selectedOptions.includes(
                      "I had to wait longer for a response"
                    ) && (
                      <CheckIcon
                        sx={{ paddingRight: "10px", fontSize: "30px" }}
                      />
                    )}{" "}
                    I had to wait longer for a response
                  </Button>

                  <Button
                    className={`goodBtn ${
                      selectedOptions.includes(
                        "Anything else, please elaborate"
                      )
                        ? "itemCheck"
                        : ""
                    }`}
                    onClick={() =>
                      handleButtonClick("Anything else, please elaborate")
                    }
                    variant={
                      selectedOptions.includes(
                        "Anything else, please elaborate"
                      )
                        ? "outlined"
                        : "outlined"
                    }
                  >
                    {selectedOptions.includes(
                      "Anything else, please elaborate"
                    ) && (
                      <CheckIcon
                        sx={{ paddingRight: "10px", fontSize: "30px" }}
                      />
                    )}{" "}
                    Anything else, please elaborate
                  </Button>
                </>
              )}
            </div>
            <form onSubmit={handleSubmit} noValidate validated={validated}>
              <div>
                <textarea
                  onChange={(e) => setCommentData(e.target.value)}
                  value={CommentData}
                  style={{
                    resize: "none",
                    width: "100%",
                    borderRadius: "6px",
                    height: "100px",
                    padding: "10px",
                  }}
                  className="feedbackInput"
                  type="text"
                  placeholder="Provide additional Feedback"
                  required
                />
              </div>

              <div style={{ fontSize: "12px", paddingBottom: "10px" }}>
                Your valuable input aids us in enhancing the chatbot's
                performance for an even more seamless and effective user
                experience.
              </div>

              <Button
                onClick={handleSubmit}
                disabled={isLoading}
                className="submit_btn"
                type="submit"
              >
                {isLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span style={{ paddingLeft: "10px" }}>Submit...</span>
                  </>
                ) : (
                  "Submit"
                )}
              </Button>
            </form>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default FeedbackModel;
